export const marketplaceContract = {
  abi: [
    {
      inputs: [],
      stateMutability: 'nonpayable',
      type: 'constructor',
    },
    {
      inputs: [],
      name: 'Marketplace__ERC721AddressExists',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ERC721AddressNotAdded',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ERC721AddressNotAllowed',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ERC721ZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__FeeZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__InvalidListingId',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__InvalidPrice',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ListingAlreadyCancelled',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ListingNotActive',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NFTNotApprovedForMarketplaceContract',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NFTNotOwnedByMsgSender',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NftAlreadyListed',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NotEnoughPaymentTokenApproved',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NotOwnerOrSellerOrAllowedColletion',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NotSeller',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__OwnerZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__RoyaltyZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__SellerCannotBuy',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__TokenZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ZeroPrice',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ArrayLengthMismatch',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__BidAmountZero',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__BidNotActive',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NotBidder',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__BidderCannotBeSeller',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__InsufficientBidderAllowance',
      type: 'error',
    },
    {
      inputs: [],
      name: 'OwnablePausable__OwnerAccountZeroAddress',
      type: 'error',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: '__nftContract',
          type: 'address',
        },
      ],
      name: 'AddressAdded',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: '__nftContract',
          type: 'address',
        },
      ],
      name: 'AddressRemoved',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'seller',
          type: 'address',
        },
      ],
      name: 'Canceled',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'uint8',
          name: 'version',
          type: 'uint8',
        },
      ],
      name: 'Initialized',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'seller',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'nftContract',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'tokenId',
          type: 'uint256',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'price',
          type: 'uint256',
        },
      ],
      name: 'Listed',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'previousOwner',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'OwnershipTransferred',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'Paused',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'price',
          type: 'uint256',
        },
      ],
      name: 'PriceUpdated',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'buyer',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'seller',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'price',
          type: 'uint256',
        },
      ],
      name: 'Sale',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'uint256',
          name: 'bidId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'bidder',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'BidPlaced',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'uint256',
          name: 'bidId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'bidder',
          type: 'address',
        },
      ],
      name: 'BidCancelled',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'uint256',
          name: 'bidId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'bidder',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'BidAccepted',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'Unpaused',
      type: 'event',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_bidId',
          type: 'uint256',
        },
      ],
      name: 'acceptBid',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
      ],
      name: 'addAllowedContract',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_price',
          type: 'uint256',
        },
      ],
      name: 'buyNFT',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256[]',
          name: '_listingIds',
          type: 'uint256[]',
        },
        {
          internalType: 'uint256[]',
          name: '_prices',
          type: 'uint256[]',
        },
      ],
      name: 'batchBuyNFT',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_amount',
          type: 'uint256',
        },
      ],
      name: 'bid',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_bidId',
          type: 'uint256',
        },
      ],
      name: 'cancelBid',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
      ],
      name: 'cancelListing',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_tokenId',
          type: 'uint256',
        },
      ],
      name: 'cancelListing',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
      ],
      name: 'getListingByListingId',
      outputs: [
        {
          components: [
            {
              internalType: 'bool',
              name: 'listed',
              type: 'bool',
            },
            {
              internalType: 'bool',
              name: 'sold',
              type: 'bool',
            },
            {
              internalType: 'address',
              name: 'seller',
              type: 'address',
            },
            {
              internalType: 'address',
              name: 'nftContract',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'tokenId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'price',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Listing',
          name: '',
          type: 'tuple',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_tokenId',
          type: 'uint256',
        },
      ],
      name: 'getListingByTokenId',
      outputs: [
        {
          components: [
            {
              internalType: 'bool',
              name: 'listed',
              type: 'bool',
            },
            {
              internalType: 'bool',
              name: 'sold',
              type: 'bool',
            },
            {
              internalType: 'address',
              name: 'seller',
              type: 'address',
            },
            {
              internalType: 'address',
              name: 'nftContract',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'tokenId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'price',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Listing',
          name: '',
          type: 'tuple',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'getListingCount',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_tokenId',
          type: 'uint256',
        },
      ],
      name: 'getTokenClaimDetails',
      outputs: [
        {
          internalType: 'uint256',
          name: '_tokenValue',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_unclaimedTokens',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_claimedTokens',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_owner',
          type: 'address',
        },
        {
          internalType: 'address',
          name: '_paymentToken',
          type: 'address',
        },
        {
          internalType: 'address',
          name: '_revenueWallet',
          type: 'address',
        },
        {
          internalType: 'address',
          name: '_royaltyAddress',
          type: 'address',
        },
      ],
      name: 'initialize',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
      ],
      name: 'isAllowedContract',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_tokenId',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_price',
          type: 'uint256',
        },
      ],
      name: 'listNFT',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'owner',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'pause',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'paused',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'paymentToken',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
      ],
      name: 'removeAllowedContract',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'renounceOwnership',
      outputs: [],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'revenueWallet',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'royaltyAddress',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'transferOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'unpause',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_price',
          type: 'uint256',
        },
      ],
      name: 'updateListingPrice',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
  ] as const,
}
